import { isTablet } from "..";
const animateImageSection = (element) => {
    const observer = new IntersectionObserver(([entry], obs) => {
        if (entry.isIntersecting) {
            element.classList.add('is-visible');
            obs.unobserve(element);
        }
    }, {
        threshold: isTablet ? 0.1 : 0.2,
        rootMargin: isTablet ? "-100px" : "0px"
    });
    observer.observe(element);
};
const registerImageSectionAnimations = () => {
    const sectionelements = document.querySelectorAll('[data-anim="image"]');
    sectionelements.forEach(el => animateImageSection(el));
};
export default registerImageSectionAnimations;
